import FloatingActionMenu from 'emerald-ui/lib/FloatingActionMenu';
import FloatingActionMenuItem from 'emerald-ui/lib/FloatingActionMenuItem';
import Icon from 'emerald-ui/lib/Icon';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs(
    [{ component: FloatingActionMenu, componentName: 'FloatingActionMenu' }],
    'FloatingActionMenu',
    FloatingActionMenuItem,
    'FloatingActionMenuItem',
    true
  ),
  description: 'A FloatingActionMenu is a customized menu used with a FloatingActionButton.',
  codeSamples: [
    {
      title: 'Default',
      scope: { FloatingActionMenu, FloatingActionMenuItem, Icon },
      whiteBackground: true,
      code: `<div>
  <div
    className="eui-floating-action-dropdown eui-dropdown"
    style={{ marginLeft: '50px', top: '-56px' }}
  >
    <FloatingActionMenu show tooltipsAtRight>
      <FloatingActionMenuItem title="Create" eventKey="1">
        <Icon name="create" />
      </FloatingActionMenuItem>
      <FloatingActionMenuItem title="Mark as complete" eventKey="2">
        <Icon name="done" />
      </FloatingActionMenuItem>
      <FloatingActionMenuItem title="Favorite" eventKey="3">
        <Icon name="favorite" />
      </FloatingActionMenuItem>
    </FloatingActionMenu>
  </div>
  <div style={{ height: '184px' }} />
</div>`,
    },
  ],
};
